import { memo } from 'react'

/**
 * Base skeleton loader component with shimmer animation
 */
const SkeletonLoader = memo(({ 
  width = '100%', 
  height = '20px', 
  borderRadius = '8px', 
  className = '' 
}) => {
  return (
    <div
      className={`skeleton-loader ${className}`}
      style={{
        width,
        height,
        borderRadius,
        background: 'linear-gradient(90deg, #263E57 14.9%, #899CBD 29.81%, #263E57 44.71%, #263E57 100%)',
        backgroundSize: '200% 100%',
        animation: 'shine 1.5s ease-in-out infinite',
      }}
    />
  )
})

SkeletonLoader.displayName = 'SkeletonLoader'

export default SkeletonLoader